import jsPDF from 'jspdf';
import { esbn_init } from './EncodeSans-Black-normal';
import { esbold_init } from './EncodeSans-Bold-bold';
import { esreg_init } from './EncodeSans-Regular-normal';

import { formatNumber, formatDate } from '../utils/std.js'

export class PdfStyle {
	constructor(tcs, fn, fsty, size) {
		this.textColors = tcs ? tcs : [0x00, 0x00, 0x00];
		this.fontName = fn ? fn : "Encode";
		this.fontStyle = fsty ? fsty : "";
		this.fontSize = size ? size : 10;
	}
}

export class PdfHelper {
	para(doc, x, y, style, text) {
		doc.setFont(style.fontName, style.fontStyle)
		doc.setTextColor(style.textColors[0], style.textColors[1], style.textColors[2])
		doc.setFontSize(style.fontSize)
		doc.text(text, x, y)
	}

	blueTextColors = [0x00, 0x4A, 0x80]; 	//"#004A80";
	blueBackgroundColors = [0x00, 0x4A, 0x80]; 	//"#004A80";
	//blackTextColors = [0x00, 0x00, 0x00]; 
	whiteTextColors = [0xFF, 0xFF, 0xFF]; 
	stdFontName = "EncodeSans-Black";
	//stdFontName = "Helvetica";

	buildDoc = function (groups, sections, totalScore) {
		esbn_init(jsPDF.API)
		esbold_init(jsPDF.API)
		esreg_init(jsPDF.API)

		//console.log("createPDF");
		let pdfName = "Resilience-Report";
		var doc = new jsPDF();
		let h1StyleBonW = new PdfStyle(this.blueTextColors, "EncodeSans-Bold", "normal", 48)
		let h2StyleBonW = new PdfStyle(this.blueTextColors, "EncodeSans-Regular", 'normal', 36)
		let h3StyleBonW = new PdfStyle(this.blueTextColors, "EncodeSans-Regular", 'normal', 20)

		let h3StyleWonB = new PdfStyle(this.whiteTextColors, "EncodeSans-Regular", 'normal', 20)
		//let h4StyleWonB = new PdfStyle(this.whiteTextColors, "EncodeSans-Regular", 'normal', 18)
		let h3StyleBoldWonB = new PdfStyle(this.whiteTextColors, "EncodeSans-Black", 'normal', 20)
		let h4StyleBoldWonB = new PdfStyle(this.whiteTextColors, "EncodeSans-Bold", 'normal', 18)
		
		let h5StyleWonB = new PdfStyle(this.whiteTextColors, "EncodeSans-Regular", 'normal', 12)

		//var fonts = doc.getFontList();
		//console.dir(fonts);

		let x = 10
		let y = 40
		this.para(doc, x, y, h2StyleBonW, "Resilient Residence"); y += 20
		this.para(doc, x, y, h1StyleBonW, ["Cyclone Resilience", "Report"]); y += 35
		let today = new Date();
		this.para(doc, x, y, h3StyleBonW, formatDate(today)); y += 8

		// Now blue background

		const width = doc.internal.pageSize.getWidth();
		const height = doc.internal.pageSize.getHeight();
		
		doc.setDrawColor(this.blueBackgroundColors[0], this.blueBackgroundColors[1], this.blueBackgroundColors[2])
		doc.rect(0, y, width, height-y, 'F')

		y += 12

		this.para(doc, x, y, h3StyleWonB, "Cyclone Resilience Score"); y += 10
		this.para(doc, x, y, h3StyleBoldWonB, formatNumber(totalScore, 1)); y += 20

		sections.forEach(section => {
			let group = groups.find(g => g.groupId == section.groupId)
			if (section.hasScore) {
				this.para(doc, x, y, h5StyleWonB, group.name); y += 10
				this.para(doc, x, y, h4StyleBoldWonB, formatNumber(group.unweightedScore, 1)); y += 15
			}
		})

		return { document: doc, file: pdfName + ".pdf" }
	}
}